"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importDefault(require("react"));
var DayOfWeekTimer_1 = __importDefault(require("./DayOfWeekTimer"));
var RangePromoTimer_1 = __importDefault(require("./RangePromoTimer"));
var PromoTimer = function (_a) {
    var timerType = _a.timerType, startAt = _a.startAt, endAt = _a.endAt, hideFinishLabel = _a.hideFinishLabel, activeDayOfWeek = _a.activeDayOfWeek;
    return (react_1.default.createElement(react_1.default.Fragment, null, timerType !== apps_shared_1.TIMER_TYPE.RANGE ? (react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) },
        react_1.default.createElement(DayOfWeekTimer_1.default, { activeDayOfWeek: activeDayOfWeek, hideFinishLabel: hideFinishLabel }))) : (react_1.default.createElement(react_1.default.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) },
        react_1.default.createElement(RangePromoTimer_1.default, { startAt: startAt, endAt: endAt, hideFinishLabel: hideFinishLabel })))));
};
exports.default = PromoTimer;
